// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_timeline_status_enum */
var FermentationTimelineStatusEnum;
(function (FermentationTimelineStatusEnum) {
    FermentationTimelineStatusEnum["PLANNED"] = "PLANNED";
    FermentationTimelineStatusEnum["DUE"] = "DUE";
    FermentationTimelineStatusEnum["COMPLETED"] = "COMPLETED";
    FermentationTimelineStatusEnum["MISSED"] = "MISSED";
    FermentationTimelineStatusEnum["SKIPPED"] = "SKIPPED";
})(FermentationTimelineStatusEnum || (FermentationTimelineStatusEnum = {}));
;
export default FermentationTimelineStatusEnum;
/** Zod schema for fermentation_timeline_status_enum */
export const fermentationTimelineStatusEnum = z.nativeEnum(FermentationTimelineStatusEnum);
//# sourceMappingURL=FermentationTimelineStatusEnum.js.map